// 金額の表示
export function displayYenField () {
  const formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY'
  });

  let fields = document.querySelectorAll('.yen-field');

  for (let i = 0; i < fields.length; i++) {
    if (!!fields[i]) {
      let hidden_field = document.getElementById(fields[i].id + '_' +'value');

      if (!!hidden_field) {
        fields[i].value = formatter.format(hidden_field.value);
      }
    }
  }
}

// 金額の入力フィールド
export function yenField () {
  let fields = document.querySelectorAll('.yen-field');

  for (let i = 0; i < fields.length; i++) {
    if (!!fields[i]) {

      fields[i].addEventListener('focus', function(event) {
        this.select()
      });

      let isComposing = false;

      fields[i].addEventListener('compositionstart', function(event) {
        isComposing = true;
      });

      fields[i].addEventListener('input', function(event) {
        if (!isComposing) {
          formatMoney(fields[i])
        }
      });

      fields[i].addEventListener('compositionend', function(event) {
        formatMoney(fields[i])
        isComposing = false;
      });
    }
  }
}

// 金額の入力を変換
function formatMoney(field) {
  const formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY'
  });

  let money = field.value.replace(/[^0-9]/g, '');

  if (!!money) {
    if (parseInt(money) < 0 || parseInt(money) > 10000000) {
      money = '10000000';
    }
    field.value = formatter.format(money);

    let hidden_field = document.getElementById(field.id + '_' +'value');

    if (!!hidden_field) {
      hidden_field.value = money;
    }
  }
}